
export function saveToCache(data) {
    console.log('Saving to cache')
    localStorage.setItem('cachedBars', JSON.stringify(data));
	console.log(data)
}

export function loadFromCache() {
    // const data = localStorage.getItem('cachedBars');
	return null
    // return data ? JSON.parse(data) : null;
}

export function parseJwt(token) {
	if (!token) {
		console.error("Invalid token");
		return null;
	}
	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const payload = JSON.parse(window.atob(base64));

		if (!payload) {
			console.error("Invalid payload");
			return null;
		}

		return payload;
	} catch (error) {
		console.error("Invalid token", error);
		return null;
	}
}

// functions/datafeed.js

// --- Caché por rango exacto (se mantiene) ---
const evKey = ({ from, to, currency }) =>
  `events:${currency || "ALL"}:${from || 0}:${to || 0}`;

export function saveEventsCache(params, data) {
  try {
    localStorage.setItem(evKey(params), JSON.stringify({ data, ts: Date.now() }));
  } catch (_) {
    // ignore
  }
}

export function loadEventsCache(params) {
  try {
    const raw = localStorage.getItem(evKey(params));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.data) ? parsed.data : null;
  } catch (_) {
    return null;
  }
}

// --- NUEVO: bucket rodante de 30 días desde “ahora” ---
const EV_LAST30_KEY = (currency) => `events:last30:${currency || "ALL"}`;

export function saveEventsLast30(currency, data) {
  try {
    localStorage.setItem(
      EV_LAST30_KEY(currency),
      JSON.stringify({ data, ts: Date.now() })
    );
  } catch (_) {
    // ignore
  }
}

export function loadEventsLast30(currency) {
  try {
    const raw = localStorage.getItem(EV_LAST30_KEY(currency));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.data) ? parsed.data : null;
  } catch (_) {
    return null;
  }
}
